import { Usuario } from "../../types";
import { usuarios } from "../../data/mockData";

interface HeaderProps {
  usuarioActual: Usuario;
  onUsuarioChange: (usuario: Usuario) => void;
}

export function Header({ usuarioActual, onUsuarioChange }: HeaderProps) {
  const rolColors: Record<string, string> = {
    admin: "bg-red-100 text-red-700",
    ejecutivo: "bg-green-100 text-green-700",
    arquitecto: "bg-blue-100 text-blue-700",
    abogado: "bg-purple-100 text-purple-700",
  };

  return (
    <header className="bg-white border-b border-slate-200 px-6 py-4">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-xl font-bold text-slate-800">G&G CRM Simple</h1>
          <p className="text-sm text-slate-500">
            Gestion de Clientes y Casos
          </p>
        </div>

        <div className="flex items-center gap-4">
          <select
            value={usuarioActual.id}
            onChange={(e) => {
              const usuario = usuarios.find(
                (u) => u.id === Number(e.target.value)
              );
              if (usuario) onUsuarioChange(usuario);
            }}
            className="px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {usuarios.map((usuario) => (
              <option key={usuario.id} value={usuario.id}>
                {usuario.nombre}
              </option>
            ))}
          </select>

          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center text-white font-medium">
              {usuarioActual.nombre.charAt(0)}
            </div>
            <div>
              <p className="text-sm font-medium text-slate-800">
                {usuarioActual.nombre}
              </p>
              <span
                className={`text-xs px-2 py-0.5 rounded-full ${
                  rolColors[usuarioActual.rol] || "bg-slate-100 text-slate-700"
                }`}
              >
                {usuarioActual.rol}
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
